(() => {
  const initialize = root => {
    root.querySelectorAll('.kh-edit').forEach(edit => {
      if (edit.dataset.kouklaReady) return;
      edit.dataset.kouklaReady = 'true';
      const buttons = [...edit.querySelectorAll('.kh-filter')];
      const cards = [...edit.querySelectorAll('.kh-card')];
      const count = edit.querySelector('.kh-count');
      const more = edit.querySelector('.kh-more');
      const moreLabel = edit.querySelector('.kh-more-label');
      buttons.forEach(button => button.addEventListener('click', () => {
        const category = button.dataset.filter;
        buttons.forEach(item => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        let visible = 0;
        cards.forEach(card => {
          card.hidden = category !== 'all' && card.dataset.category !== category;
          if (!card.hidden) visible++;
        });
        count.textContent = `Showing ${visible} ${visible === 1 ? 'piece' : 'pieces'}`;
        more.href = category === 'jewellery' ? edit.dataset.jewelleryUrl : edit.dataset.bagsUrl;
        moreLabel.textContent = category === 'jewellery' ? 'Shop all jewellery' : 'Shop all bags & clutches';
      }));
    });
  };
  document.addEventListener('DOMContentLoaded', () => initialize(document));
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
